export default ({ commit }) => {
  commit("SET_OPEN");
};
